export default __webpack_public_path__ + "static/media/partner_hero.ff387570.png";